import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Thermometer, Shield, Feather, Gauge } from 'lucide-react';

const TechnologySection = () => {
  return (
    <section id="technology" className="technology-section section-padding bg-slate-50">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="section-header text-center mb-16">
          <h2 className="section-title">Our Technology</h2>
          <div className="title-underline" />
          <p className="section-subtitle mt-6">
            Proprietary aerogel platform enabling tailored material architectures optimized for performance, durability, and integration.
          </p>
        </div>

        {/* Placeholder for Future 3D Visualization */}
        <div className="mb-16">
          <div className="w-full h-[500px] bg-gradient-to-br from-blue-500 via-blue-600 to-blue-800 rounded-xl flex items-center justify-center relative overflow-hidden">
            <div className="absolute inset-0 opacity-10">
              <div className="grid grid-cols-8 grid-rows-6 h-full w-full">
                {[...Array(48)].map((_, i) => (
                  <div key={i} className="border border-white/20" />
                ))}
              </div>
            </div>
            <div className="relative z-10 text-center px-6">
              <h3 className="text-white text-3xl font-bold mb-4">Aerogel Molecular Structure</h3>
              <p className="text-cream-100 text-lg max-w-2xl mx-auto">
                Ultra-low density nanoporous material with exceptional thermal insulation properties. 
                Our proprietary aerogel platform achieves 5-10× better performance than conventional materials.
              </p>
              <div className="mt-8 flex justify-center gap-8">
                <div className="text-center">
                  <p className="text-4xl font-bold text-cream-200">99.8%</p>
                  <p className="text-cream-300 text-sm mt-1">Porosity</p>
                </div>
                <div className="text-center">
                  <p className="text-4xl font-bold text-cream-200">0.013</p>
                  <p className="text-cream-300 text-sm mt-1">W/m·K Thermal Conductivity</p>
                </div>
                <div className="text-center">
                  <p className="text-4xl font-bold text-cream-200">1200°C</p>
                  <p className="text-cream-300 text-sm mt-1">Max Temperature</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Tech Features */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          <Card className="tech-card">
            <CardContent className="p-6">
              <div className="tech-icon-wrapper mb-4">
                <Thermometer className="w-8 h-8" />
              </div>
              <h3 className="tech-card-title mb-3">Low Thermal Conductivity</h3>
              <p className="tech-card-description">Extremely low thermal conductivity for superior insulation performance</p>
            </CardContent>
          </Card>
          
          <Card className="tech-card">
            <CardContent className="p-6">
              <div className="tech-icon-wrapper mb-4">
                <Shield className="w-8 h-8" />
              </div>
              <h3 className="tech-card-title mb-3">High Temperature Resistance</h3>
              <p className="tech-card-description">Withstands extreme temperatures in demanding environments</p>
            </CardContent>
          </Card>
          
          <Card className="tech-card">
            <CardContent className="p-6">
              <div className="tech-icon-wrapper mb-4">
                <Feather className="w-8 h-8" />
              </div>
              <h3 className="tech-card-title mb-3">Lightweight & Space-Efficient</h3>
              <p className="tech-card-description">Minimal weight with maximum insulation efficiency</p>
            </CardContent>
          </Card>
          
          <Card className="tech-card">
            <CardContent className="p-6">
              <div className="tech-icon-wrapper mb-4">
                <Gauge className="w-8 h-8" />
              </div>
              <h3 className="tech-card-title mb-3">Tunable Properties</h3>
              <p className="tech-card-description">Customizable density and form factor for specific applications</p>
            </CardContent>
          </Card>
        </div>

        {/* Material Formats */}
        <div className="material-formats-section">
          <h3 className="formats-title text-center mb-12">Material Formats</h3>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="format-card">
              <div className="format-content">
                <p className="format-text">Aerogel composites</p>
              </div>
            </div>
            <div className="format-card">
              <div className="format-content">
                <p className="format-text">Flexible sheets & panels</p>
              </div>
            </div>
            <div className="format-card">
              <div className="format-content">
                <p className="format-text">Battery-grade thermal barriers</p>
              </div>
            </div>
            <div className="format-card">
              <div className="format-content">
                <p className="format-text">Structural insulation modules</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TechnologySection;
